import { Flex, space, Text } from '@workday/canvas-kit-react'
import React from 'react'
import TimeDisplayOption from '../models/TimeDisplayOptions'
import { AlertModel } from '../../models/AlertModel'
import { AgencyModel } from '../../models/AgencyModel'
import { PPLinkify } from '../../components/PPLinkify'

export interface AlertCardProps {
  timeDisplayOption: TimeDisplayOption
  alert: AlertModel
  agency: AgencyModel
}

const AlertCard = ({ timeDisplayOption, alert, agency }: AlertCardProps) => {
  return (
    <Flex flexDirection="column" gap={space.xs}>
      <Flex flexDirection="row" alignItems="center" gap={space.xxs}>
        <Text typeLevel="subtext.large">{agency.shortName}</Text>
        <Flex.Item flex="1" />
        <Text typeLevel="subtext.large" fontWeight="medium">
          {timeDisplayOption === 'LOCAL' && alert.formattedDateTime(undefined, true)}
          {timeDisplayOption === 'AGENCY' && alert.formattedDateTime(agency.timeZone, true)}
          {timeDisplayOption === 'BOTH' &&
            `${alert.formattedDateTime(undefined, true)} (${alert.formattedDateTime(agency.timeZone, false)})`}
        </Text>
      </Flex>
      <Flex flexDirection="row" gap={space.xxs}>
        <img src={alert.listIconURL()} width={48} height={48} />
        <Flex flexDirection="column" alignItems="start">
          <Text typeLevel="heading.small">{alert.callType.description}</Text>
          <Text typeLevel="body.small">
            <PPLinkify>{alert.message}</PPLinkify>
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default AlertCard
